import { useEffect, useState } from "react";
import { Button, Offcanvas, Carousel, Badge, NavLink } from "react-bootstrap";
import { superAdminMetaServices } from "../../../APIServices/MetaManagement/superAdminMetaServices";

const IntegrationDetails = ({ Show, Hide, Title, integrationId }) => {
  const [openModule, setOpenModule] = useState("overview");
  const [loader, setLoader] = useState(false);
  const [integrationData, setIntegrationData] = useState("");

  const getSingleIntegrationDetails = async () => {
    setLoader(true);
    let data =
      await superAdminMetaServices.getSingleIntegrationDetails(integrationId);
    setIntegrationData(data?.data || []);
    setLoader(false);
  };

  useEffect(() => {
    if (integrationId) {
      getSingleIntegrationDetails();
    }
  }, [integrationId]);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: 500 }}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title style={{ fontSize: 15 }} className="hstack gap-2">
          <img src={integrationData?.icon} style={{ height: 20 }} />
          {integrationData?.title}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="p-0">
        {integrationData?.installationDetails && (
          <div className="hstack gap-2 p-2">
            <Button
              variant={
                openModule === "overview" ? "primary" : "outline-primary"
              }
              size="sm"
              className="w-100"
              onClick={() => setOpenModule("overview")}
            >
              Overview
            </Button>
            <Button
              variant={
                openModule === "installation" ? "primary" : "outline-primary"
              }
              size="sm"
              className="w-100"
              onClick={() => setOpenModule("installation")}
            >
              Installation
            </Button>
          </div>
        )}
        {openModule === "overview" && (
          <>
            {integrationData?.banners?.length > 0 && (
              <>
                {integrationData?.sliders ? (
                  <Carousel
                    interval={3000}
                    indicators
                    className="integration-carousel mb-3 px-2"
                  >
                    {integrationData?.banners?.map((icon, index) => (
                      <Carousel.Item key={index}>
                        <img
                          className="d-block w-100 rounded"
                          src={icon}
                          alt={`Slider ${index + 1}`}
                        />
                      </Carousel.Item>
                    ))}
                  </Carousel>
                ) : (
                  <div className="integration-carousel mb-3">
                    <img
                      className="d-block w-100 rounded"
                      src={integrationData?.banners?.[0]}
                      alt="Slider"
                    />
                  </div>
                )}
              </>
            )}
            {integrationData?.tags?.length > 0 && (
              <div className="hstack justify-content-between mb-2 px-2">
                <p
                  style={{ fontSize: 14 }}
                  className="text-muted m-0 hstack gap-1 flex-wrap"
                >
                  <span className="fw-bold">Works With: </span>
                  {integrationData?.tags?.map((tags, index) => (
                    <Badge className="rounded-1" key={index}>
                      {tags}
                    </Badge>
                  ))}
                </p>
              </div>
            )}
            <div
              className="overflow-auto px-2"
              style={{ height: "calc(100vh - 397px)" }}
            >
              <div
                dangerouslySetInnerHTML={{ __html: integrationData?.overview }}
              />
            </div>
          </>
        )}
        {openModule === "installation" && (
          <>
            <div
              className="overflow-auto px-2"
              style={{ height: "calc(100vh - 155px)" }}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: integrationData?.installationDetails,
                }}
              />
            </div>
          </>
        )}
      </Offcanvas.Body>
      <div className="justify-content-end p-2 border-top hstack gap-2">
        <NavLink to={integrationData?.learnMoreButtonKey || "#"} target="_blank">
          <Button
            size="sm"
            disabled={!integrationData?.learnMoreButton}
            variant="outline-primary"
            title={`Learn more about ${Title} integration`}
          >
            Learn More
          </Button>
        </NavLink>
        {integrationData?.installButton && (
          integrationData?.installButtonActionType === "activate" ?
            <Button size="sm" variant="primary" title={`Install ${Title}`}>
              Install Now
            </Button>
            :
            <NavLink to={integrationData?.installButtonKey || "#"} target="_blank">
              <Button size="sm" variant="primary" title={`Install ${Title}`}>
                Install Now
              </Button>
            </NavLink>
        )}
      </div>
    </Offcanvas>
  );
};

export default IntegrationDetails;
